import { CompleteMultipartUploadCommand, ListMultipartUploadsCommand, ListObjectsV2Command, ListObjectsV2Request, ListObjectVersionsCommand, Part, PutObjectCommand, S3Client, UploadPartCommand } from "@aws-sdk/client-s3"
import MyHttpHandler from "../../../utils/MyHttpHandler"

export async function bucketObjectsList(bucketname: string, prefix: string | undefined, client: S3Client, delimeter = '/') {
    const input: ListObjectsV2Request = {
        Bucket: bucketname,
        Delimiter: delimeter,
        Prefix: prefix,
    }
    const cmd = new ListObjectsV2Command(input)
    return client.send(cmd)
}

export async function bucketVersionsList(bucketname: string, prefix: string | undefined, client: S3Client) {
    const input = {
        Bucket: bucketname,
        Delimiter: '/',
        Prefix: prefix,
    }
    const cmd = new ListObjectVersionsCommand(input)
    return client.send(cmd)
}

export async function uploadsList(bucketname: string, client: S3Client) {
    const input = {
        Bucket: bucketname,
    }
    const cmd = new ListMultipartUploadsCommand(input)
    return client.send(cmd)
}

export const uploadFile = async (client: S3Client, bucket: string | undefined, prefix: string | undefined, s: File, filename: string, httpHandler: MyHttpHandler, onProgress: (path: string, precent: number) => void, abortSignal?: AbortSignal) => {
    httpHandler.onProgress$.subscribe((progress) => {
        const percentComplete = progress.progressEvent.loaded / progress.progressEvent.total * 100;
        const p = decodeURI(progress.path.slice(progress.path.slice(1).indexOf('/') + 2, progress.path.indexOf('?')));
        if (p.indexOf(filename) !== -1) {
            onProgress(p, percentComplete);
        }
    });

    const command = new PutObjectCommand({
        Bucket: bucket,
        Key: prefix ? prefix + filename : filename,
        // Key: prefix ? prefix + (s.webkitRelativePath || s.name) : (s.webkitRelativePath || s.name),
        Body: s,
    });

    return client.send(command, { abortSignal: abortSignal });

    // try {
    //     const response = await client.send(command);
    // } catch (caught) {
    //     if (
    //         caught instanceof S3ServiceException &&
    //         caught.name === 'EntityTooLarge'
    //     ) {
    //         console.error(
    //             `Error from S3 while uploading object to ${bucket}. \
    //   The object was too large. To upload objects larger than 5GB, use the S3 console (160GB max) \
    //   or the multipart upload API (5TB max).`,
    //         );
    //     } else if (caught instanceof S3ServiceException) {
    //         console.error(
    //             `Error from S3 while uploading object to ${bucket}. ${caught.name}: ${caught.message}`,
    //         );
    //     } else {
    //         throw caught;
    //     }
    // }
}

export const uploadFilePart = async (client: S3Client, bucket: string | undefined, data: Blob, key: string, partNumber: number, uploadId: string | undefined, httpHandler: MyHttpHandler, onProgress: (path: string, precent: number) => void, abortSignal?: AbortSignal) => {
    // const myHttpHandler = new MyHttpHandler();
    httpHandler.onProgress$.subscribe((progress) => {
        const percentComplete = progress.progressEvent.loaded / progress.progressEvent.total * 100;
        const p = decodeURI(progress.path.slice(progress.path.slice(1).indexOf('/') + 2, progress.path.indexOf('?')));
        if (p.indexOf(key) !== -1) {
            onProgress(p, percentComplete);
        }
    });

    const params = {
        Body: data,
        Bucket: bucket,
        Key: key,
        PartNumber: partNumber,
        UploadId: uploadId
    };
    const command = new UploadPartCommand(params);

    return client.send(command, { abortSignal: abortSignal });
}

export const uploadFilePartial = async (
    client: S3Client,
    bucket: string | undefined,
    s: File,
    prefix: string | undefined,
    filename: string,
    uploadId: string | undefined,
    httpHandler: MyHttpHandler,
    onProgress: (path: string, precent: number) => void,
    abortSignal?: AbortSignal,
    uploadedChunks?: Part[],
) => {
    const chunkSize = uploadedChunks?.at(0)?.Size || Math.ceil(Math.max(s.size / 10, 5 * 1024 * 1024));
    const chunkCount = Math.ceil(s.size / chunkSize);
    const k = prefix ? prefix + filename : filename;
    // const k = prefix ? prefix + (s.webkitRelativePath || s.name) : (s.webkitRelativePath || s.name);
    const parts: { ETag?: string, PartNumber: number }[] = [];

    const cmds = [];
    for (let chunkIndex = 0; chunkIndex < chunkCount; chunkIndex++) {
        const from = chunkIndex * chunkSize;
        const to = from + chunkSize;
        const data = s.slice(from, to);

        const params = {
            Body: data,
            Bucket: bucket,
            Key: k,
            PartNumber: chunkIndex + 1,
            UploadId: uploadId
        };
        // const cmd = new UploadPartCommand(params);
        if (uploadedChunks) {
            const part = uploadedChunks.find((part) => part.PartNumber === chunkIndex + 1);
            if (part) {
                parts.push({ ETag: part.ETag, PartNumber: chunkIndex + 1 });
            } else {
                cmds.push(params);
            }
        } else {
            cmds.push(params);
        }
    }

    let i = 1;
    const u = uploadedChunks?.length || 0;
    onProgress(k, (100 * u / chunkCount));
    for (const cmd of cmds) {
        const j = i;
        const task = await uploadFilePart(client, bucket, cmd.Body, cmd.Key, cmd.PartNumber, cmd.UploadId, httpHandler, (path, p) => onProgress(path, (100 * ((u + j - 1) / chunkCount) + (p / chunkCount))), abortSignal);
        // onProgress(100 * i / chunkCount);
        parts.push({ ETag: task.ETag, PartNumber: cmd.PartNumber });
        i++;
    }

    parts.sort((a, b) => a.PartNumber - b.PartNumber);

    const input = {
        Bucket: bucket,
        Key: k,
        MultipartUpload: {
            Parts: parts
        },
        UploadId: uploadId
    };
    const command = new CompleteMultipartUploadCommand(input);
    return client.send(command);
}

interface MenuItemCommandEvent {
    /**
     * Browser event
     */
    originalEvent: React.SyntheticEvent;
    /**
     * Selected item instance.
     */
    item: MenuItem;
}

/**
 * Menu item options
 */
interface MenuItemOptions {
    /**
     * Callback to invoke on click.
     * @param {React.SyntheticEvent} event - Browser event.
     */
    onClick(event: React.SyntheticEvent): void;
    /**
     * Style class of the component.
     */
    className: string;
    /**
     * Style class of the label element.
     */
    labelClassName: string;
    /**
     * Class name of the options icon.
     */
    iconClassName: string;
    /**
     * Default element created by the component.
     */
    element: React.ReactNode;
    /**
     * All component props
     */
    props: any;
}

export interface MenuItem {
    /**
     * Unique identifier of the menuitem.
     */
    id?: string | undefined;
    /**
     * Text of the menuitem.
     */
    label?: string | undefined;
    /**
     * Icon of the item. It can be a string, React.JSX.Element or method.
     */
    icon?: any | undefined;
    /**
     * External link to navigate when item is clicked.
     */
    url?: string | undefined;
    /**
     * An array of children the menuitems.
     */
    items?: MenuItem[] | MenuItem[][] | undefined;
    /**
     * Visibility of submenu.
     * @defaultValue false
     */
    expanded?: boolean | undefined;
    /**
     * When set as true, disables the menuitem.
     * @defaultValue false
     */
    disabled?: boolean | undefined;
    /**
     * When set as false, hides the menuitem.
     * @defaultValue true
     */
    visible?: boolean | undefined;
    /**
     * Specifies where to open the linked document.
     */
    target?: string | undefined;
    /**
     * Defines the item as a separator.
     * @defaultValue false
     */
    separator?: boolean | undefined;
    /**
     * Inline style of the menuitem.
     */
    style?: React.CSSProperties | undefined;
    /**
     * Style class of the menuitem.
     */
    className?: string | undefined;
    /**
     * Callback to execute when item is clicked.
     * @param {MenuItemCommandEvent} event - Custom command event.
     */
    command?(event: MenuItemCommandEvent): void;
    /**
     * Template of the menuitem.
     */
    template?: React.ReactNode | ((item: MenuItem, options: MenuItemOptions) => React.ReactNode);
    /**
     * The data of the menuitem.
     */
    data?: any | undefined;
}
